import { ComponentType, FC } from 'react';

export type ContentRendererProps = {
  rawNodes: string;
  nodes: any[];
};

export type SidebarCalloutProps = {
  contentData: {
    rawNodes: string;
    nodes: any[];
  };
  content?: ComponentType<ContentRendererProps>;
}

const SidebarCallout: FC<SidebarCalloutProps> = ({
  contentData,
  content: ContentRenderer,
}) => {
  const rawContent =
    typeof contentData?.rawNodes === 'string' ? contentData.rawNodes : JSON.stringify(contentData?.rawNodes ?? '');

  return (
    <div className="bg-gray-100 rounded-12 p-3">
      <div className="text-editorialP1 text-gray-800 font-serif">
        {rawContent && ContentRenderer && (
          <ContentRenderer
            rawNodes={rawContent}
            nodes={contentData?.nodes ?? []}
          />
        )}
        {rawContent && !ContentRenderer && (
          <div
            className="text-caption1 font-sans [&_a]:underline [&_a]:text-blue-90"
            dangerouslySetInnerHTML={{ __html: rawContent }}
          />
        )}
      </div>
    </div>
  );
}

export default SidebarCallout;
